// extracted by css-extract-rspack-plugin
export default {"Root":"yRCWw","StatusContainer":"GVdyr","StatusIconContainer":"fNcJ1"};